export default __webpack_public_path__ + "8d87276400e2dacbe0bdfeefc12d86fc.png";